import { DefaultClass } from "../classes/DefaultClass";
import { Filter } from "../classes/Filter";
import { utils } from "../utils";

/**
 *  Класс для страницы афишы
 * @extends DefaultClass
 */
export class Index extends DefaultClass {
	constructor() {
		super();
		this.$items = $("#js-index");
	}

	init() {
		utils.toTop(this.$items);
		this.getLanguages().then(() => {
			const filter = new Filter();
			filter.setActionMore();
		});
	}
}

const index = new Index();
index.init();
